import * as ReactDOMServer from "react-dom/server";

export const getSVGForCSS = (svg, color) => {
  // this utility returns a string that can be used with the background-image css property
  // background-image: ${string};
  const encodeSVG = (s) => {
    s = `${s}`.replace(/currentColor/g, `${color}`);
    let b64 = encodeURIComponent(
      s.replace(/\<\?xml.+\?\>|\<\!DOCTYPE.+]\>/g, "")
    )
      .replace(/%20/g, " ")
      .replace(/%3D/g, "=")
      .replace(/%3A/g, ":")
      .replace(/%2F/g, "/")
      .replace(/%22/g, "'")
      .replace(/%3Csvg/g, "%3Csvg xmlns='http://www.w3.org/2000/svg'");

    return 'url("data:image/svg+xml,' + b64 + '")';
  };

  const codeString = ReactDOMServer.renderToString(svg);
  return encodeSVG(codeString);
};

export default getSVGForCSS;
